import { render } from "./SoftConfirm.vue?vue&type=template&id=5dd1a071&scoped=true"
import script from "./SoftConfirm.vue?vue&type=script&lang=js"
export * from "./SoftConfirm.vue?vue&type=script&lang=js"

import "./SoftConfirm.vue?vue&type=style&index=0&id=5dd1a071&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd1a071"]])

export default __exports__